import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import TransactionServices from "../TransactionServices";
import Pagination from "components/Common/newPagination";
import InvoiceImportLog from "./InvoiceImportLog"; 
import InvoiceManualInput from "./InvoiceManualInput";

export default function InvoiceDetailBox(param: any) {
    console.log(param)
    let [checkMsg, setcheckMsg] = useState(false);
    let [fileError, setfileError] = useState(false);
    let [isActiveTab, setisActiveTab] = useState(0);
    let [progress, setProgress] = useState(0);
    let [fileToUpload, setfileToUpload] = useState(null);
    let [countFactSales, setcountFactSales] = useState(0);
    let [custTplCommit, setcustTplCommit] = useState(false);
    let [templateList, setTemplateList] = useState<any>([]);
    let [invoiceSelect, setInvoiceSelect] = useState<any>([]);
    let [importStatusLog, setImportStatusLog] = useState(false);
    let [fileuploadStatus, setfileuploadStatus] = useState(false);
    let [transferMsgCommit, settransferMsgCommit] = useState(false);
    let [importStatusValid, setimportStatusValid] = useState(false);
    let [TransactionSummary, setTransactionSummary] = useState<any>([]);
    let [loadCustomMetadataMain, setloadCustomMetadataMain] = useState(false);
    let [impHolStreamDetailData, setImpHolStreamDetailData] = useState<any>([]);
    let [custTplCommitViewJobStatus, setcustTplCommitViewJobStatus] = useState(false);
    let [impHolStreamDetailDataTemp, setImpHolStreamDetailDataTemp] = useState<any>([]);

    const onClose = () => { param.InvoiceDetailClose(); }


    useEffect(() => {
        if (param?.selectInvoice) {
            setInvoiceSelect({ ...param.selectInvoice });

            if (isActiveTab == 0) {
                apiCall();
            }
        }
    }, [param?.selectInvoice]);

    const apiCall = () => {

        TransactionServices.customTransactionSummary(param.selectInvoice?.invId).then((respond: any) => {
            TransactionSummary = respond
            setTransactionSummary(TransactionSummary)

            if ((Math.abs(respond?.homeValue - respond?.knett_c) <= 0.05)) {
                custTplCommit = true;
                custTplCommitViewJobStatus = false;
            }
        })

        TransactionServices.checkImportLogFile(param.selectInvoice?.invoiceNum).then((respond: any) => {
            if (respond > 0) {
                importStatusValid = true
                setimportStatusValid(importStatusValid)

            }
        })

        TransactionServices.getFactSalesRawCount({ invoiceRef: param.selectInvoice?.invoiceNum }).then((respond: any) => {
            countFactSales = respond
            setcountFactSales(countFactSales)
        })

        TransactionServices.getMetadataMain({ kontactCode: param.selectInvoice?.accountCode }).then((respond: any) => {
            templateList = respond
            setTemplateList(templateList)
        })
    }

    var pagination = { pageNumber: 1, pageSize: 10 }
    const impHolStream_DetailData = () => {
        if (!loadCustomMetadataMain) {
            loadCustomMetadataMain = true
            setloadCustomMetadataMain(loadCustomMetadataMain)

            TransactionServices.impHolStreamDetailData({ invoiceRef: param.selectInvoice?.invoiceNum }).then((respond: any) => {
                impHolStreamDetailDataTemp = respond
                setImpHolStreamDetailDataTemp(impHolStreamDetailDataTemp)
                impHolStreamDetailData = respond?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                setImpHolStreamDetailData(impHolStreamDetailData)
            })
        } else {

            loadCustomMetadataMain = false
            setloadCustomMetadataMain(loadCustomMetadataMain)
        }
    }

    const impHolStreamDetailPagination = (e: any) => {
        pagination.pageNumber = e.pageNumber
        pagination.pageSize = e.pageSize

        impHolStreamDetailData = impHolStreamDetailDataTemp?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setImpHolStreamDetailData(impHolStreamDetailData);
    }

    const importLogOnChange = () => {
        importStatusLog = false;
        setImportStatusLog(importStatusLog)
    }

    const exportDSPMapping = (e: any) => {
        var url = 'salesAnalysis/getContactMapping/' + invoiceSelect?.kontactCode + '/'
        window.open(url);
    }

    const loadFile = () => {
        TransactionServices.salesAnalysisUpload(fileToUpload).then((value: any) => {
            console.log(value)

            progressTiming(value)
            if (value?.lines) {
                progress = 100;
                setProgress(progress)
            }
        })
    }

    const progressTiming = (e: any) => {
        setProgress(30);
        setProgress(50);
        setProgress(80);

        if (e >= 0) {
            setProgress(100)
        }
    }

    const fileupload = (event: any) => {
        const fileName = event.target.files[0];
        console.log(event)
        if (fileName) {
            setfileToUpload(fileName);
            fileuploadStatus = true
            setfileuploadStatus(fileuploadStatus);
        }
    }



    const ItemCodeClose = (e: any) => { }
    const closeTerritoryDetail = (e: any) => { }
    const onCustTplCommit = () => { }
    const onSelectTerritory = (e: any) => { }

    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-10 paddingCenterBox bgTransparent' }} >
                <div className="ws-12 box allowHscroll allowVscroll">

                    <div className="box-header well">
                        <h2 className="pull-left ">  Account Detail for  </h2>
                        <a className="btn icon-btn edit pull-left " title="Acc: Warner Desc: null">Warner</a>
                        <a title="Edit Invoice" className="btn btn-sm icon-btn edit pull-right hide" data-ng-hide="true" ng-click="invoiceEdit(invoice, indexI)">
                            <i className="icon-edit-pencil"></i> Edit Invoice
                        </a>
                    </div>

                    <div className="box-content">
                        <div className="ws-12">

                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th className="text-right bg-level2">Account:</th>
                                        <td >{invoiceSelect?.accountCode} ({invoiceSelect?.kontactDisplay})</td>
                                        <th className="text-right bg-level2">Invoice num:</th>
                                        <td >{invoiceSelect?.invoiceNum}</td>
                                        <th className="text-right bg-level2">Invoice Date:</th>
                                        <td >{invoiceSelect?.invoiceDate}</td>
                                    </tr>
                                    <tr>
                                        <th className="text-right bg-level2">Invoice Description:</th>
                                        <td >{invoiceSelect?.invDescription}</td>
                                        <th className="text-right bg-level2">Royalty Period:</th>
                                        <td >{invoiceSelect?.royaltyPeriod}</td>
                                        <th className="text-right bg-level2">Approved:</th>
                                        <td>
                                            {!invoiceSelect?.approvalStatus && <span>
                                                {invoiceSelect?.approvalStatus && <i className="icon-tick icon-btn edit" ></i>}
                                                {!invoiceSelect?.approvalStatus && <i className="icon-close icon-btn delete"></i>}
                                            </span>}
                                            {invoiceSelect?.approvalStatus && <span > <i className="icon-tick icon-btn edit"></i></span>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="text-right bg-level2">Currency Value:</th>
                                        <td >{invoiceSelect?.currencyValue}</td>
                                        <th className="text-right bg-level2">Exch Rate:</th>
                                        <td >{invoiceSelect?.exchRate1}</td>
                                        <th className="text-right bg-level2">Home Value:</th>
                                        <td >{invoiceSelect?.homeValue}</td>
                                    </tr>
                                    <tr>
                                        <th className="text-right bg-level2">Currency Code:</th>
                                        <td >{invoiceSelect?.currencySign}</td>
                                        <th className="text-right bg-level2">Type:</th>
                                        <td >{invoiceSelect?.headerType}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div className="ws-12">
                            <div className="ws-12 mt">
                                <ul className="nav nav-tabs nav-justified">
                                    <li className={isActiveTab == 0 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => setisActiveTab(0)}>Custom Template</li>
                                    <li className={isActiveTab == 2 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => setisActiveTab(2)}>Manual Input</li>
                                    <li className={isActiveTab == 3 ? "icon-btn edit fill" : "icon-btn edit"} onClick={() => setisActiveTab(3)}>Automated</li>
                                </ul>

                                {isActiveTab == 0 && <div className="ws-12 " >

                                    <div className="box mt borderRounded">
                                        <div className="box-header well">
                                            <div className="ws-12">
                                                <h2 className="ws-3 ">Custom Template</h2>
                                                <div className="ws-9 pull-right">
                                                    <button title="Download Template Mapping Details" className="btn icon-btn edit btn-sm pull-right" ng-hide="browseFile()" onClick={exportDSPMapping}><i className="icon-download1"></i> Download</button>
                                                    <button title="Refresh Fact Sales Entry" className="btn icon-btn delete btn-sm pull-right" onClick={apiCall}><i className="icon-refresh"></i> Refresh </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="box-content">
                                            {fileError && <div className="alert-alert-info">Please select a file first</div>}

                                            <div className="ws-12">
                                                <div className="ws-12">
                                                    <div className="form-format ws-6">
                                                        <label className="ws-3 mt ">Template name</label>
                                                        <div className="label-entries ws-9">
                                                            <input type="text" placeholder="Enter template name" value={templateList?.[0]?.templateName} name="tplName" id="tplName" required readOnly />
                                                        </div>
                                                    </div>
                                                    {TransactionSummary?.lines != 0 && <div className="form-format ">
                                                        <label className="w-13 ">Multiple Files</label>
                                                        <div className="label-entries ws-10">
                                                            <input type="checkbox" className="checkbox-inline " data-ng-change="checkMultipleFiles(multipleFiles)" />
                                                        </div>
                                                    </div>}

                                                    {TransactionSummary?.lines != 0 && custTplCommit && countFactSales == 0 && <div className="form-format mt">
                                                        <label className="control-label w-13 ">Include Zero Value Items</label>
                                                        <div className="label-entries ws-10">
                                                            <input type="checkbox" className="checkbox-inline " data-ng-change="checkZeroValues(zeroValues)" />
                                                        </div>
                                                    </div>}

                                                    {TransactionSummary?.lines > 0 && custTplCommit && <div className="form-format mt ">
                                                        <label className="control-label w-13 ">Change Negative Sales</label>
                                                        <div className="label-entries ws-10">
                                                            <input type="checkbox" className="checkbox-inline " data-ng-change="checkNegativeValues(invoice)" />
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="ws-12">
                                                    <div className="form-format ws-5 mt">
                                                        <label className="ws-3 mt">Location</label>
                                                        <div className="label-entries width-auto">
                                                            <label className="btn icon-btn edit btn-file pull-left btn-sm ps height35">
                                                                <i className="icon-upload"></i>
                                                                <input type="file" className="hide" onChange={(e) => fileupload(e)} />
                                                            </label>

                                                        </div>

                                                        {fileuploadStatus && <a className="icon-btn edit pull-left height35" onClick={loadFile}><i className="icon-loading"></i> Save</a>}
                                                    </div>

                                                    <div className="ws-5 ptl">
                                                        <div className="progress">
                                                            <div className="btn-lightBlue mo ps borderRounded mts" role="progressbar">  0%  </div>
                                                        </div>
                                                    </div>

                                                    <div className="ws-2">
                                                        {importStatusValid && <button className="icon-btn primary pull-right height35" onClick={() => setImportStatusLog(true)}>Import status</button>}
                                                    </div>
                                                </div>
                                            </div>

                                            {checkMsg && <span className="alert-warning" >By unchecking multiple files checkbox, you are going to delete all the previous files that you have uploaded.</span>}
                                        </div>
                                    </div>

                                    {TransactionSummary?.lines != 0 && <div className="ws-12 box mt mb borderRounded">

                                        <div className="box-header well">
                                            {<h2><i className="fa fa-table"></i> Load fact Sales </h2>}

                                        </div>

                                        {<div className="box-content ws-12">
                                            <div className="ws-12">
                                                <table className="table borderRounded">
                                                    <tbody>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <td className="text-right ">{TransactionSummary?.lines}</td>
                                                            <th className="bg-level2">No of Lines</th>
                                                        </tr>
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                            <th className="bg-level2">Currency Value</th>
                                                            <th className="bg-level2">Home Value</th>
                                                        </tr>
                                                        <tr>
                                                            <th className="bg-level2">Header Totals</th>
                                                            <td className="text-right ">{TransactionSummary?.currencyValue}</td>
                                                            <td className="text-right ">{TransactionSummary?.homeValue}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="bg-level2">File Totals</th>
                                                            <td className="text-right ">{TransactionSummary?.knett}</td>
                                                            <td className="text-right ">{TransactionSummary?.knett_c}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <div className="box-footer">
                                                    {custTplCommit && countFactSales == 0 && <button className="btn icon-btn edit pull-left" onClick={onCustTplCommit}>Commit</button>}
                                                    <button className="icon-btn primary pull-left hide " >Matching</button>
                                                    {custTplCommitViewJobStatus && <p className="pull-right"><a className="pull-right">View Job Status</a></p>}
                                                    {TransactionSummary?.lines != 0 && <button className="btn icon-btn edit pull-right" ng-click="updateField(invoice);" title="Update Field" data-ng-show="tabs.active == 0"> Update</button>}
                                                </div>

                                                <div className="row-fluid hide">
                                                    <div className="ws-6 ">Number of territories not matching</div>
                                                    <div className="ws-6 "></div>
                                                </div>

                                                <div className="row-fluid hide">
                                                    <div className="ws-6 ">Number of formats/source codes not matching</div>
                                                    <div className="ws-6 "></div>
                                                </div>

                                                <div className="row-fluid hide">
                                                    <div className="ws-6 ">Catalog/Tracks not matching</div>
                                                    <div className="ws-6 "></div>
                                                </div>

                                            </div>
                                        </div>}
                                    </div>}

                                    {TransactionSummary?.lines != 0 && <div className="ws-12 box borderRounded">
                                        <div className="box-header well">
                                            {loadCustomMetadataMain && <h2 className="ws-4  "><i className="fa fa-table"></i> {impHolStreamDetailDataTemp.length} record(s) found</h2>}
                                            {!loadCustomMetadataMain && <h2 className="ws-4"><i className="fa fa-table"></i> Load Custom Template Metadata</h2>}
                                            <div className="ws-8 pull-right">
                                                <button className="btn pull-right btn-xs icon-btn info" onClick={impHolStream_DetailData}>
                                                    <i className={!loadCustomMetadataMain ? "icon-plus icon-plus1" : "icon-minus1"}></i>
                                                </button>

                                                {transferMsgCommit && <span className="alert-warning" data-ng-show="transferMsgCommit">The data has been queued for transfer, click refresh to see partial data.</span>}
                                                <button title="Refresh Partial Data" className="btn icon-btn delete btn-sm pull-right" data-ng-click="getImpHolStreamDetails()"><i className="icon-refresh"></i> Refresh</button>
                                            </div>
                                        </div>

                                        {loadCustomMetadataMain && <div className="box-content ws-12">
                                            {(impHolStreamDetailDataTemp.length) > 0 && <div className="ws-12 ">
                                                <div className="form-format ws-6">
                                                    <label >Filter table</label>
                                                    <div className="label-entries">
                                                        <input id="filterTblCFactSales" type="text" className="form-control " />
                                                    </div>
                                                </div>
                                            </div>}

                                            {(impHolStreamDetailDataTemp.length) == 0 && <div className="alert alert-info ">No data to display</div>}

                                            <div className="ws-12">
                                                {(impHolStreamDetailDataTemp.length) > 0 && <table className="NewTable">
                                                    <thead>
                                                        <tr>
                                                            <th >Invoice Ref</th>
                                                            <th >Analysis</th>
                                                            <th >Date</th>
                                                            <th >Units Sold</th>
                                                            <th >Monetary Value</th>
                                                            <th >Format</th>
                                                            <th >Territory</th>
                                                            <th >Sub Content</th>
                                                            <th >Sub Format</th>
                                                            <th >Sub Provider</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            impHolStreamDetailData?.map((values: any) => {
                                                                return (
                                                                    <tr>
                                                                        <td >{values?.invoiceref}</td>
                                                                        <td >{values?.analysis}</td>
                                                                        <td >{values?.invDate}</td>
                                                                        <td >{values?.kQuantity}</td>
                                                                        <td >{values?.kNett_c}</td>
                                                                        <td >{values?.formatCode}</td>
                                                                        <td >{values?.territory}</td>
                                                                        <td >{values?.subContent}</td>
                                                                        <td >{values?.subFormat}</td>
                                                                        <td >{values?.subProvider}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>}
                                            </div>

                                            <div className="clearfix">

                                                {
                                                    (() => {
                                                        if (impHolStreamDetailDataTemp.length && impHolStreamDetailDataTemp.length > 10) {
                                                            return <Pagination onPageChange={impHolStreamDetailPagination} totalRow={impHolStreamDetailDataTemp.length} />
                                                        }
                                                    })()
                                                }

                                            </div>
                                        </div>}
                                    </div>}

                                </div>}

                                {isActiveTab == 1 && <div className="ws-12 slide">

                                    <div className="box-header well">  <h2 >Fact Sales Entry</h2> </div>

                                    <div className="box-content">
                                        <form className="form-horizontal ng-pristine ng-valid" name="genTplForm">
                                            <fieldset>
                                                <div className="row-fluid">
                                                    <div className="ws-6">

                                                        <label className="control-label ">Location</label>

                                                        <div className="label-entries">
                                                            <div className="btn icon-btn edit btn-sm"><i className="icon-upload"></i></div>
                                                        </div>
                                                    </div>

                                                    <div className="ws-6">
                                                        <a className="btn icon-btn edit pull-right btn-sm "><i className="icon-upload icon-white"></i> Load</a>

                                                        <div className="form-format">
                                                            <div className="progress">
                                                                <div className="progress-bar " role="progressbar"> 0% </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </div>


                                    <div className="box-content">
                                        <div className="box-header well">
                                            <h2 ><i className="fa fa-table"></i> <span data-ng-bind="genTplFactSalesTotalItems" ></span> record(s) found</h2>
                                        </div>
                                        <div className="table-responsive_big">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th >Invoice Ref</th>
                                                        <th >Analysis</th>
                                                        <th >Date</th>
                                                        <th >Units Sold</th>
                                                        <th >Monetary Value</th>
                                                        <th >Format</th>
                                                        <th >Territory</th>
                                                        <th >Operation</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td ></td>
                                                        <td ></td>
                                                        <td ></td>
                                                        <td ></td>
                                                        <td className="text-right "></td>
                                                        <td ></td>
                                                        <td ></td>
                                                        <td>
                                                            <a title="Edit" className="btn icon-btn edit"><i className="icon-edit"></i></a>
                                                            <a title="Delete" className="btn icon-btn delete"><i className="icon-trashcan"></i></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <ul className="pagination ng-isolate-scope" total-items="genTplFactSalesTotalItems" max-size="3" >



                                        </ul>
                                    </div>

                                    <div className="row-fluid ">
                                        Home value: 1 <br />
                                        Total fact sales: <br />
                                    </div>
                                </div>}

                                {isActiveTab == 2 && <InvoiceManualInput invoiceSelect={invoiceSelect} />}

                                {isActiveTab == 3 && <div className="ws-12 slide">

                                    <div className="row-fluid sortable box box-header-fix form-box">
                                        <div className="box-header well">
                                            <h2 >Files Listed on Server for Account</h2>
                                        </div>
                                        <div className="ws-6">
                                            <select className=" filename results  ws-10 "></select>
                                        </div>

                                        <div className="box-content file-box">
                                            <div className="ws-12">
                                                <div className="form-format">
                                                    <div >
                                                        <button type="button" className="icon-btn edit"><i className="icon-upload"></i></button>
                                                    </div>
                                                    <div className="ws-9">
                                                        <input type="text" name="kontactDisplay" id="contractDetails.kontactDisplay" />
                                                    </div>
                                                </div>

                                                <div className="form-format">
                                                    <div >
                                                        <button type="button" className="icon-btn edit">LINK</button>
                                                    </div>
                                                    <div className="ws-9">
                                                        <input type="text" name="" placeholder="" id="contractDetails.kontactDisplay" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row-fluid sortable box box-header-fix  form-box">
                                        <div className="box-header well">
                                            <h2><i className="fa fa-table"></i> <span data-ng-bind="" ></span> record(s) found</h2>
                                        </div>

                                        <div className="box-content">
                                            <div className="table-responsive_big">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>InvoiceRef</th>
                                                            <th>Analysis</th>
                                                            <th>Date</th>
                                                            <th>Units Sold</th>
                                                            <th>Monetary Value</th>
                                                            <th>Format</th>
                                                            <th>Territory</th>
                                                            <th>Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <a title="Edit" className="btn-xs icon-btn edit"><i className="icon-edit"></i></a>
                                                                <a title="Delete" className="btn-xs icon-btn delete"><i className="icon-trashcan"></i></a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <ul className="pagination ng-isolate-scope" total-items="factSalesTotalItems" max-size="3" >
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="row-fluid ">
                                        Home value: 1<br />
                                        Total fact sales: <br />
                                    </div>

                                </div>}

                            </div>

                            <div className="box-footer">
                                <button className="btn icon-btn delete btn-sm ng-hide " onClick={onClose}><i className="icon-close"></i> Close</button>
                            </div>

                        </div>
                    </div>

                    {
                        (() => {
                            if (importStatusLog) {
                                return <InvoiceImportLog selectInvoice={param?.selectInvoice} importStatusLog={importStatusLog} importLogOnChange={importLogOnChange} />
                            }
                        })()
                    }

                </div >
            </Modal >
        </div >
    )
}